const onRun = () => {
    // Last minute - Top offers
    const topOfferWrap = document.querySelector('.js-top-offer-wrap');
    let topOffers = Array.from(document.querySelectorAll('.top-offer__row'));

    if (topOfferWrap !== null) {
        const topOffer = topOfferWrap.querySelector('.top-offers');
        const topOfferAllButton = topOfferWrap.querySelector('.js-top-offer-all');
        const badges = document.querySelector('.top-offers__badges');
        const countryButtons = badges.querySelectorAll('.badge');
        const selectElement = document.querySelector('.top-offers__select');
        const allOption = selectElement.querySelector('option[value="all"]');

        // Function to hide/show offers based on the selected country
        function handleHideAllCountries() {
            topOffers.forEach((topOffer) => {
                topOffer.classList.add('hidden');
            });
        }

        const showCountryOffers = (countryIdToShow)=>  {
            topOffers.forEach((topOffer,) => {
                const countryId = topOffer.dataset.countryId;

                if (countryIdToShow === countryId || countryIdToShow === 'all') {
                    topOffer.classList.remove('hidden');
                }
            });
        }

        const toggleAllButton = () => {
            const visibleTopOffers = topOffers.filter(
                (topOffer) => !topOffer.classList.contains('hidden')
            );

            if (visibleTopOffers.length < 5) {
                topOfferAllButton.classList.add('hidden');
                topOffer.classList.add('js-show-all');
            } else {
                topOfferAllButton.classList.remove('hidden');
                topOffer.classList.remove('js-show-all');
            }
        }

        // Function to update visible offers and numbering
        function updateVisibleOffers() {
            const visibleTopOffers = topOffers.filter(
                (topOffer) => !topOffer.classList.contains('hidden')
            );

            visibleTopOffers.forEach((topOffer, index) => {
                const topOfferNumber = topOffer.querySelector('.top-offer__number');
                topOfferNumber.textContent = String(index + 1).padStart(2, '0');
            });
        }

        // Event handler for "Show All" button
        topOfferAllButton.addEventListener('click', function () {
            const isShowed = topOffer.classList.toggle('js-show-all');
            if (isShowed) {
                this.textContent = 'Zobraziť menej';
            } else {
                this.textContent = 'Zobraziť všetky';
            }
        });

        // Event handler for both the buttons and the select element
        function handleCountrySelection(countryId) {
            handleHideAllCountries();
            showCountryOffers(countryId);
            toggleAllButton();
            updateVisibleOffers();
        }

        // Attach click event listener to each button
        countryButtons.forEach((button) => {
            button.addEventListener('click', function () {
                badges.querySelector('.is-active').classList.remove('is-active');
                button.classList.add('is-active');

                handleCountrySelection(this.dataset.id);
            });
        });

        // Attach change event listener to the select element
        selectElement.addEventListener('change', function () {
            const countryId = this.value;

            if (countryId === 'all') {
                allOption.selected = true;
                handleCountrySelection('all');
            } else {
                handleCountrySelection(countryId);
            }
        });
    }
};
if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}

